import React from "react";

const isDevelopment = process.env.NODE_ENV === "development";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false,
      error: null,
      errorInfo: null,
    };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render shows the fallback UI
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // ✅ Production-ready error handling
    if (!isDevelopment && window.errorReporting) {
      window.errorReporting.captureException(error, { extra: errorInfo });
    }

    this.setState({
      error: error,
      errorInfo: errorInfo,
    });
  }

  render() {
    if (this.state.hasError) {
      // ✅ Production-ready error UI
      return (
        <div className="error-boundary-container">
          <div className="error-boundary-card">
            <div className="error-boundary-icon">⚠️</div>
            <h2>Something went wrong</h2>
            <p>We're sorry, but there was a problem loading this page.</p>
            <div className="error-boundary-actions">
              <button
                className="error-boundary-button primary"
                onClick={() => window.location.reload()}
              >
                Reload Page
              </button>
              <button
                className="error-boundary-button secondary"
                onClick={() => window.history.back()}
              >
                Go Back
              </button>
            </div>
            {this.props.showDetails && (
              <details style={{ whiteSpace: "pre-wrap", marginTop: "20px" }}>
                <summary>Technical Details (Development Mode)</summary>
                <div className="error-details">
                  <p>
                    <strong>Error:</strong>{" "}
                    {this.state.error &&
                      (typeof this.state.error === "object"
                        ? this.state.error.message ||
                          JSON.stringify(this.state.error)
                        : this.state.error.toString())}
                  </p>
                  {this.state.errorInfo && (
                    <p>
                      <strong>Component Stack:</strong>
                      {this.state.errorInfo.componentStack}
                    </p>
                  )}
                </div>
              </details>
            )}
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
